import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { Route } from 'react-router-dom';
import * as paths from 'Paths';



const DomainsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/custom/domains" */
    'routes/Custom/DomainsRoute'
  )
));

const AddDomainRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/custom/add-domain" */
    'routes/Custom/AddDomainRoute'
  )
));

const PagesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/custom/pages" */
    'routes/Custom/PagesRoute'
  )
));

const UpdatePageRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/custom/update-page" */
    'routes/Custom/UpdatePageRoute'
  )
));



const getCustomRoutes = () => {
  return [
    {path: paths.getPathCustomDomains(), component: DomainsRoute},
    {path: paths.getPathAddCustomDomain(), component: AddDomainRoute},
    {path: paths.getPathCustomPages(), component: PagesRoute},

    {path: paths.getPathAddCustomPage(), component: UpdatePageRoute},
    {path: paths.getPathEditCustomPage(":pageId"), component: UpdatePageRoute},
  ]
}



export { getCustomRoutes };

